import { createIcon } from "@chakra-ui/icons";

// Created from Check.svg

export const CheckIcon = createIcon({
  displayName: "Check",
  viewBox: "0 0 24 24",
  path: (
    <g>
      <path
        id="Vector"
        d="M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinejoin="round"
        fill="transparent"
      />
      <polyline
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinejoin="round"
        points="9 11 12 14 22 4"
        fill="transparent"
      />
    </g>
  ),
});
